import { render, staticRenderFns } from "./AutoComp.vue?vue&type=template&id=1b287ac4&"
import script from "./AutoComp.vue?vue&type=script&lang=js&"
export * from "./AutoComp.vue?vue&type=script&lang=js&"
import style0 from "./AutoComp.vue?vue&type=style&index=0&id=1b287ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports